const ru = {
  10000001: 'Празднование 2-й годовщины SuperEx',
  10000002: 'Регистрируйтесь и получайте отличные награды!',
  10000003: 'В зависимости от количества участников, чем больше участников, тем больший призовой фонд будет разблокирован, вплоть до 10 000USDT. ',
  10000004: '2-я годовщина SuperEx',
  10000005: 'Выиграйте 20 000 USDT в конкурсе по празднованию контракта',
  10000006: `Конкурс рейтинга торговых объемов: Разблокируйте главный приз - бонусный пул в размере <span style="color: #ffc72b;">10,000</span> USDT. `,
  10000007: 'Чемпионат по фьючерсам',
  10000008: 'Выиграйте 20 000 USDT в конкурсе по празднованию контракта',
}
export default ru



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/ru.js